import { Button } from '@/components/ui/button'
import { CardCheckbox } from '@/components/ui/CardCheckbox'
import { PolicyChangeKind, type PolicyChangePolicy } from '@/models/policyChange'
import { ClaimStepShell } from '../Claims/ClaimStepShell'
import { PoliciesIncluded } from './PoliciesIncluded'
import { KIND_GROUPS, KIND_LABELS } from './policyChangeCopy'

interface StepWhatsChangingProps {
  policies: PolicyChangePolicy[]
  kinds: PolicyChangeKind[]
  onKindsChange: (kinds: PolicyChangeKind[]) => void
  saving: boolean
  onNext: () => void
}

const GROUPS = [...KIND_GROUPS, { title: 'Something else', kinds: [PolicyChangeKind.OTHER] }]

export function StepWhatsChanging({
  policies,
  kinds,
  onKindsChange,
  saving,
  onNext,
}: StepWhatsChangingProps) {
  const toggle = (kind: PolicyChangeKind, checked: boolean) =>
    onKindsChange(checked ? [...kinds, kind] : kinds.filter((picked) => picked !== kind))

  return (
    <ClaimStepShell
      step={1}
      stepCount={4}
      title="What's changing?"
      subtitle="Pick everything that applies. Not sure where it fits? Pick Something else and tell us in your own words."
    >
      <PoliciesIncluded policies={policies} />
      {GROUPS.map((group) => (
        <div key={group.title} className="flex flex-col gap-2">
          <div className="font-mono text-xs text-neutral-500 uppercase">{group.title}</div>
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            {group.kinds.map((kind) => (
              <CardCheckbox
                key={kind}
                isChecked={kinds.includes(kind)}
                onChange={(checked) => toggle(kind, checked)}
              >
                {KIND_LABELS[kind]}
              </CardCheckbox>
            ))}
          </div>
        </div>
      ))}
      <div className="flex justify-end">
        <Button
          type="button"
          disabled={!kinds.length}
          onClick={onNext}
          loading={saving ? 'Saving…' : undefined}
        >
          Next →
        </Button>
      </div>
    </ClaimStepShell>
  )
}
